<section class="preview-section" id="decouvrir">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Découvrez par vous-même</span>
      <h2>Wealthlane : votre copilote patrimonial</h2>
      <p>Reliez automatiquement l'analyse comptable à l'ingénierie patrimoniale du dirigeant</p>
    </div>

    <div class="preview-container">
      <div class="preview-screen">
        <div [class.active]="activeSection === 0" class="screen-content" id="screen-import" >
          <div class="screen-icon">📁</div>
          <div class="screen-title">Import comptable automatique</div>
          <p>Glissez-déposez votre FEC et laissez l'IA structurer toutes vos données en quelques secondes</p>
        </div>
        <div [class.active]="activeSection === 1" class="screen-content" id="screen-analysis" >
          <div class="screen-icon">📊</div>
          <div class="screen-title">Analyse automatique approfondie</div>
          <p>24 ratios financiers calculés et commentés automatiquement avec insights personnalisés</p>
        </div>
        <div [class.active]="activeSection === 2" class="screen-content" id="screen-solutions">
          <div class="screen-icon">💼</div>
          <div class="screen-title">50+ solutions patrimoniales</div>
          <p>SCPI, holding, assurance-vie, stratégies fiscales... Recommandations adaptées au profil</p>
        </div>
        <div [class.active]="activeSection === 3" class="screen-content" id="screen-academy" >
          <div class="screen-icon">🎓</div>
          <div class="screen-title">Wealthlane Academy</div>
          <p>Formez-vous avec nos fiches pédagogiques, vidéos interactives et obtenez votre certification</p>
        </div>
        <div [class.active]="activeSection === 4" class="screen-content" id="screen-report" >
          <div class="screen-icon">📄</div>
          <div class="screen-title">Rapport professionnel en marque blanche</div>
          <p>Export PDF personnalisable aux couleurs de votre cabinet, prêt à présenter au client</p>
        </div>
      </div>

      <div class="preview-features">
        <button [class.active]="activeSection === 0" class="feature-btn" data-screen="screen-import" (click)="activeSection = 0">
          <div class="feature-icon">📂</div>
          <div class="feature-content">
            <h4>Import comptable automatique</h4>
            <p>FEC, grand livre ou balance générale. Connexion API future avec Pennylane, Tiime, etc.</p>
          </div>
        </button>

        <button [class.active]="activeSection === 1" class="feature-btn" data-screen="screen-analysis" (click)="activeSection = 1">
          <div class="feature-icon">🤖</div>
          <div class="feature-content">
            <h4>IA d'interprétation comptable</h4>
            <p>Analyse automatique du bilan, SIG, et 24 ratios financiers avec commentaires personnalisés.</p>
          </div>
        </button>

        <button [class.active]="activeSection === 2" class="feature-btn" data-screen="screen-solutions" (click)="activeSection = 2">
          <div class="feature-icon">💰</div>
          <div class="feature-content">
            <h4>50+ solutions patrimoniales</h4>
            <p>SCPI, holding, assurance-vie, stratégies fiscales... Recommandations adaptées au profil.</p>
          </div>
        </button>

        <button [class.active]="activeSection === 3" class="feature-btn" data-screen="screen-academy" (click)="activeSection = 3">
          <div class="feature-icon">🎓</div>
          <div class="feature-content">
            <h4>Wealthlane Academy</h4>
            <p>Formation complète avec fiches pédagogiques, vidéos et certification professionnelle.</p>
          </div>
        </button>

        <button [class.active]="activeSection === 4" class="feature-btn" data-screen="screen-report" (click)="activeSection = 4">
          <div class="feature-icon">📋</div>
          <div class="feature-content">
            <h4>Rapport professionnel en 1 clic</h4>
            <p>Bilan patrimonial complet et personnalisable à remettre au client.</p>
          </div>
        </button>
      </div>
    </div>
  </div>
</section>

